import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { ConversationsList } from './conversations-list';
import { ContactConversationsList } from './contact-conversations-list';

interface ConversationsListWrapperProps {}

export const ConversationsListWrapper: React.FC<ConversationsListWrapperProps> = () => {
    const { actionsV2: actionsV2Enabled } = useFlags();

    // Use the new Contact-based conversation list if the feature flag is enabled
    if (actionsV2Enabled) {
        return <ContactConversationsList />;
    }

    // Otherwise, use the existing UserContact-based conversation list
    return <ConversationsList />;
};
